import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { DatosFirmaOperacion } from "../app.domain.models/datos-firma-operacion";
import { ApiService } from "../core.services/api.service";
import { Poliza } from "../app.domain.models/poliza";

@Injectable({
    providedIn: 'root'
})
export class FirmaOperacionService {

    constructor(private http: HttpClient,
        private apiService: ApiService,
    ) { }

    obtenerDatosTokenFirma(token: string): Promise<DatosFirmaOperacion> {
        return this.http.get<any>(`${environment.apiUrl}/seguro/obtenerDatosTokenFirma?token=${token}`).toPromise();
    }
    
    obtenerDatosTokenCarritoAbandonado(token: string): Promise<number> {
        return this.http.get<any>(`${environment.apiUrl}/seguro/obtenerDatosTokenCarritoAbandonado?token=${token}`).toPromise();
    }

}
